import { isEmpty } from '@jjj/components';
import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';
import { t } from '../../../../../../i18n';
import { keyBy } from '../../../../../../helpers/core';

const initState = {
  loading: false,
  isVisible: false,
  formData: {},
  reviewForm: null,
  shift: {},
  payment: null,
  proposed_started_at_time: null,
  proposed_finished_at_time: null,
  proposed_approved_break_duration: null,
  responder_notes: null,
  client_rating: null,
  talent_rating: null,
  requestor_users: null,
};

export const DEFAULT_PAYMENT = 'Instant';

function validate(attr, value) {
  let error = '';

  if (attr === 'requestor_users') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.jobs.reviewTimingsModal.approver_label') });
    }
  }

  return error;
}

function onApprove(state) {
  return { ...state, loading: true };
}

function onChangeTimings(state) {
  const { shift } = state;
  const propsArray = Object.keys(state.reviewForm);

  const reviewForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: shift?.[prop] && Object.prototype.hasOwnProperty.call(shift[prop], 'id') ? shift[prop].id : shift[prop],
      error: validate(prop, shift?.[prop]),
      touched: false,
    }),
  );

  return { ...state, loading: true, reviewForm };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.reviewForm);
  const reviewForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    reviewForm,
  };
}

function onChangeValue(state, { payload }) {
  const { attr, value } = payload;
  const { reviewForm } = state;

  reviewForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    reviewForm: {
      ...reviewForm,
    },
  };
}

function onClearStore() {
  return { ...initState };
}

function onDecline(state) {
  return { ...state, loading: true };
}

function onHideModal() {
  return onClearStore();
}

function onLoadFormDataSuccess(state, { payload }) {
  return { ...state, loading: false, formData: payload };
}

function onShowModal(state, { payload }) {
  const {
    payment,
    started_at,
    finished_at,
    approved_break_duration,
    responder_notes,
    client_rating,
    talent_rating,
    requestor_users,
  } = payload;

  const reviewForm = {
    isVisible: true,
    loading: true,
    payment: payment || DEFAULT_PAYMENT,
    proposed_started_at_time: started_at,
    proposed_finished_at_time: finished_at,
    proposed_approved_break_duration: approved_break_duration,
    responder_notes: responder_notes || '',
    client_rating: client_rating?.score?.id,
    talent_rating: talent_rating?.score?.id,
    requestor_users,
  };

  const propsArray = Object.keys(reviewForm);
  const reviewFormValidated = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: reviewForm[prop],
      error: validate(prop, reviewForm[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    reviewForm: reviewFormValidated,
    isVisible: true,
    loading: true,
    shift: payload,
    payment: payment || DEFAULT_PAYMENT,
    proposed_started_at_time: started_at,
    proposed_finished_at_time: finished_at,
    proposed_approved_break_duration: approved_break_duration,
    responder_notes: responder_notes || '',
    client_rating: client_rating?.score?.id,
    talent_rating: talent_rating?.score?.id,
  };
}

export default createReducer(initState, {
  [actions.APPROVE]: onApprove,
  [actions.CHANGE_TIMINGS]: onChangeTimings,
  [actions.CHANGE_VALUE]: onChangeValue,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.DECLINE]: onDecline,
  [actions.HIDE_MODAL]: onHideModal,
  [actions.LOAD_FORM_DATA_SUCCESS]: onLoadFormDataSuccess,
  [actions.SHOW_MODAL]: onShowModal,
  [actions.TOUCH]: onTouch,
});
